import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
    UploadErrorSummary,
    UploadErrorSummaryPayload,
} from 'src/app/shared/models/upload-job';

export interface UploadErrorSummaryListResponse {
    summaries: UploadErrorSummary[];
}

@Injectable({
    providedIn: 'root',
})
export class ImgDbUploadErrorStoreService {
    private readonly restUrl: string;

    constructor(private http: HttpClient) {
        this.restUrl = `${environment.backendUrl}/rest`;
    }

    saveUploadErrorSummary(
        imageDbId: string,
        payload: UploadErrorSummaryPayload
    ): Observable<void> {
        return this.http.post<void>(
            `${this.restUrl}/img-db/${imageDbId}/upload-errors`,
            payload
        );
    }

    getUploadErrorSummaries(
        imageDbId: string
    ): Observable<UploadErrorSummaryListResponse> {
        return this.http.get<UploadErrorSummaryListResponse>(
            `${this.restUrl}/img-db/${imageDbId}/upload-errors`,
            {
                params: { _t: Date.now().toString() },
            }
        );
    }

    clearUploadErrorSummaries(
        imageDbId: string,
        ids: string[]
    ): Observable<void> {
        return this.http.request<void>(
            'delete',
            `${this.restUrl}/img-db/${imageDbId}/upload-errors`,
            {
                body: ids,
            }
        );
    }
}
